import { Link, Outlet } from 'react-router-dom';
import { CartProvider, useCart } from './components/CartDrawer';
import { sampleProductsPath } from './lib/paths';
import './styles/sampleProducts.css';

function Shell() {
  const { count } = useCart();

  return (
    <div className="sample-products-shell">
      <header className="nav">
        <div className="nav-inner">
          <Link to={sampleProductsPath('/products')} className="brand">
            <img src="/sample-products/logo.png" alt="Nyafaz" />
          </Link>
          <nav className="nav-links">
            <Link to={sampleProductsPath('/products')}>Products</Link>
            <Link to={sampleProductsPath('/cart')}>{`Cart (${count})`}</Link>
          </nav>
        </div>
      </header>
      <div className="sp-content">
        <Outlet />
        <footer className="footer">
          <div className="footer-inner">
            <span>Powered by</span>
            <strong>Nyafaz Skincare</strong>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default function SampleProductsApp() {
  return (
    <CartProvider>
      <Shell />
    </CartProvider>
  );
}
